import { HttpClient } from './HttpClient.js';

export const MinutasService = {

    async encriptar(form){
        return await HttpClient.get('/encriptacion/'+form).then(response => response);
    },

    async getAllMinutas(){
        return  await HttpClient.get(`/minute/get-meeting-minutes-general`).then(response => response)
    },

    async saveMinuta(minuta){
        return await HttpClient.post('/minute/create-meeting-minute',minuta).then(response => response)
    },

    async editMinuta(id, minuta){
        return await HttpClient.post(`/minute/edit-meeting-minute/${id}`, minuta).then(response => response);
    },
    
    async deleteMinuta(id){
        return await HttpClient.delete(`/minute/delete-meeting-minute/${id}`).then(response => response);
    },
    
    async getUsers(){
        return await HttpClient.get('/user/get-by-dispatch').then(response => response)
    }
}